import 'scss/signup.scss';

import jstz from 'jstz';
import ReactUJS from 'javascripts/ujs/react_ujs';
import SignUp from 'components/signup/SignUp';
import SignUpSuccess from 'components/onboard/SignUpSuccess';
import Toast from 'components/shared/Toast';

function setup() {
  const timeZone = document.querySelector('#signup_form_time_zone');

  if (timeZone) {
    timeZone.value = jstz.determine().name();
  }

  window.removeEventListener('DOMContentLoaded', setup);
}

window.addEventListener('DOMContentLoaded', setup);

// Import only the SignUp react component
window.ReactUJS = ReactUJS;
window.ReactComponents = { SignUp, SignUpSuccess, Toast };
